module.exports = {
  test: 'global config',
  favIcon: 'assets/images/favicon.png',
  favIconApp: 'assets/images/favicon-app.png',
  favIconAppSVG: 'assets/images/favicon-app.svg',
};
